export type Steps = {
	id?: string;
	sequence: number;
	icon?: JSX.Element;
	description: string;
	name?: string;
	component: JSX.Element;
};

export type Side = SIDE.LEFT | SIDE.RIGHT;

export type Direction = DIRECTION.VERTICAL | DIRECTION.HORIZONTAL;

export enum SIDE {
	LEFT = 'left',
	RIGHT = 'right'
}

export enum DIRECTION {
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal'
}
